import { cycloneApiClient } from '@/shared/api/core/axios-instance';

import { delayDagMockMutation } from '@/entities/dag/api/_internal/dagMockDelay';
import { deleteAirflowDagInMockStore } from '@/entities/dag/api/_internal/dagMockStore';
import { shouldUseDagMockApi } from '@/entities/dag/api/_internal/shouldUseDagMockApi';
import type { DeleteDagRequest } from '@/entities/dag/domain/types';

export const deleteDagApi = async ({ dagUuid: rawDagUuid }: DeleteDagRequest): Promise<void> => {
  const dagUuid = rawDagUuid.trim();

  if (!dagUuid) {
    throw new Error('DAG UUID is required');
  }

  if (shouldUseDagMockApi()) {
    await delayDagMockMutation('standard');
    deleteAirflowDagInMockStore(dagUuid);
    return;
  }

  await cycloneApiClient.delete(`/dags/${dagUuid}`);
};
